module.exports = __webpack_public_path__ + "img/Steor-Icon-05.afc1a96f.svg";